import React, { useState, useEffect } from "react";
import PackageInfo from "../PackageInfo/PackageInfo";
import triangle1 from "../../../src/Images/pawana/TriangleStay/1.jpg";
import triangle2 from "../../../src/Images/pawana/TriangleStay/2.jpg";
// import triangle3 from "../../../src/Images/pawana/TriangleStay/3.jpg";
import ts1 from "../../../src/Images/pawana/TriangleStay/ts1.PNG";

import triangle4 from "../../../src/Images/pawana/TriangleStay/tlights.jpg";
// import triangle5 from "../../../src/Images/pawana/TriangleStay/5.jpg";
import room1 from "../../../src/Images/pawana/RoomStay/ys1.JPG";
import room2 from "../../../src/Images/pawana/RoomStay/2.jpg";
import room3 from "../../../src/Images/pawana/RoomStay/3.jpg";
import room4 from "../../../src/Images/pawana/RoomStay/4.jpg";
import tent1 from "../../../src/Images/pawana/TentStay/tnt1.jpg";
import tent2 from "../../../src/Images/pawana/TentStay/tnt2.jpg";
import tent3 from "../../../src/Images/pawana/TentStay/tnt3.jpg";
import t1 from "../../../src/Images/pawana/TentStay/t1.PNG";

import cb1 from "../../../src/Images/pawana/CozyCabin/cozyCabin.JPG";
import cb2 from "../../../src/Images/pawana/CozyCabin/CozyCabin3.jpg";
import cb3 from "../../../src/Images/pawana/CozyCabin/CozyCabin4.jpg";
import fs1 from "../../../src/Images/pawana/FarmStyle/fs1.jpg";
import fs2 from "../../../src/Images/pawana/FarmStyle/fs2.PNG";
// import tent4 from "../../../src/Images/pawana/TentStay/tnt4.jpg"
// import tent5 from "../../../src/Images/pawana/tnt5.jpg"
import cmn1 from "../../../src/Images/pawana/cmn1.jpg";
import cmn2 from "../../../src/Images/pawana/cmn2.jpg";
import cmn3 from "../../../src/Images/pawana/cmn3.jpg";
import cmn4 from "../../../src/Images/pawana/cmn4.jpg";
import cmn5 from "../../../src/Images/pawana/cmn5.JPG";
import cmn6 from "../../../src/Images/pawana/cmn6.JPG";
import cmn7 from "../../../src/Images/pawana/cmn7.jpg";
import cmn8 from "../../../src/Images/pawana/cmn8.jpg";
import cmn9 from "../../../src/Images/pawana/cmn9.JPG";
import cmn10 from "../../../src/Images/pawana/cmn10.jpg";
import cmn11 from "../../../src/Images/pawana/cmn11.jpg";
import cmn12 from "../../../src/Images/pawana/cmn12.JPG";
import cmn13 from "../../../src/Images/pawana/cmn13.JPG";

const PawanaCamping = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const fetchedData = {
      itinerary: {
        camping: "Pawana Lake Camping",
        day1: [
          { time: "04:00 pm", activity: "Arrival & Check-In" },
          {
            time: "04:30 pm to 06:00 pm",
            activity: "Games & Recreational Activities",
          },
          { time: "05:30 pm to 06:30 pm", activity: "Evening Tea & Snacks" },
          {
            time: "07:30 pm to 09:00 pm",
            activity: "BBQ Session (Veg & Non-Veg Limited)",
          },
          { time: "08:00 pm to 10:00 pm", activity: "DJ Music & Social Time" },
          {
            time: "10:00 pm to 11:00 pm",
            activity: "Dinner Service (Veg & Non-Veg Unlimited)",
          },
          {
            time: "11:00 pm to 12:00 am",
            activity: "Live Guitar Music & Bonfire",
          },
          {
            time: "12:00 am to 06:00 am",
            activity: "Quiet Hours / Silent Zone",
          },
        ],
        day2: [
          {
            time: "07:00 am to 08:00 am",
            activity: "Sunrise View for Early Risers",
          },
          {
            time: "08:30 am to 09:30 am",
            activity: "Morning Tea & Breakfast",
          },
          {
            time: "09:00 am to 10:30 am",
            activity:
              "Water Sports (Boating & Kayaking) - Optional / Not Included in Package",
          },
          {
            time: "11:00 am",
            activity: "Check-Out & Departure with Wonderful Memories",
          },
        ],
      },
      title: "Pawna Lake Camping – Weekend Stay & Bonfire Experience",
      showCampAdvisory: true,
      tagline: "Weekend Lake View Camping | Book Your Stay Now!",
      description: `
      Escape the city and enjoy a peaceful lakeside stay with music, bonfire, delicious food, and fun-filled activities. Pawna Lake Camping is perfect for friends, couples, families, and groups who want a relaxed getaway with comfort, nature, and memorable moments.

Choose from multiple stay options including tent stay, glass cabin, farm-style cottage, room with attached washroom, or pod stay. We also offer beautiful birthday and anniversary decorations to make your celebration extra special and picture-perfect.
    `,
      heroStats: [
        {
          label: "Stay Types",
          value: "Tent • Triangle • Glass Cabin • Farm-Style Cottage • Rooms ",
        },
        { label: "Perfect For", value: "Family / Friends / Couples / Groups" },
        {
          label: "Celebrate",
          value: "Birthday • Anniversary • Bachelor Party",
        },
      ],
      highlights: [
        "Live DJ, music, and bonfire nights",
        "Lake view camping with easy access from Pune and Mumbai",
        "Fresh food, BBQ, and unlimited dinner",
        "Beautiful birthday and anniversary decoration setup",
        "Comfortable stay choices from budget to premium options",
        "Ideal for relaxed weekends, family outings, and surprise celebrations",
      ],
      bookingSteps: [
        "Choose your stay type and share your preferred date and number of guests.",
        "Pay your booking amount through the QR code shared on the page.",
        "Send the payment screenshot on WhatsApp for confirmation.",
        "Get your final confirmation message and camp details on WhatsApp.",
      ],
      cost: {
        child: "Free (0 to 5 years)",
        childDiscounted: "50% of adult pricing",
        adult: "As per selected stay package",
        groupDiscount: "Special Group Discount Available up to 20%",
      },
      inclusions: {
        title: "What's Included ✅",
        items: [
          "Stay as per the selected package and room type",
          "Evening tea with snacks and morning breakfast",
          "Live DJ music and bonfire experience",
          "Limited BBQ for veg and non-veg guests",
          "Unlimited dinner with veg and non-veg options",
          "Tent stay with mat and blanket on a shared basis",
          "First-aid support and on-site assistance",
          "Indoor games including chess, carrom, and cards",
          "Outdoor games including cricket, badminton, archery, and volleyball",
          "Basic parking assistance and check-in support",
          "Birthday or anniversary decoration setup, if selected",
        ],
      },
      exclusions: [
        "Transportation to and from the campsite",
        "Extra meals, cold drinks, or beverages ordered separately",
        "Boating, kayaking, and other paid adventure activities",
        "Personal expenses, shopping, or souvenirs",
        "Travel insurance, tips, or porter charges",
        "Medical emergencies or evacuation expenses",
        "Costs arising from unforeseen weather or circumstances",
        "Any service or item not explicitly mentioned in the inclusion list",
      ],
      foodMenu: [
        "Evening snacks: tea and misal pav (limited servings)",
        "Veg menu: mix veg or paneer sabzi, dal tadka, chapati, steamed rice, salad, papad, and sweet dish (unlimited)",
        "BBQ: chicken and paneer (limited servings)",
        "Non-veg menu: chicken fry, chicken curry, chapati, rice, salad, and seasonal sides (unlimited)",
        "Breakfast: tea and pohe (limited servings)",
        "Special celebration cake or birthday arrangement available on request",
      ],
      bookingInstructions: [
        "To secure your reservation, please complete the booking payment using the QR code provided on this page.",
        "After payment, share the transaction screenshot on WhatsApp for confirmation and verification.",
        "Once verified, you will receive a confirmation message with trip details and a short form to confirm your preferences.",
        "For birthday or anniversary decoration requests, kindly inform us in advance so we can arrange the setup beautifully.",
      ],
      productData: [
        {
          title: "Tent Stay",
          description:
            "Best for budget-friendly weekend plans and group stays.",
          features: [
            "Shared stay experience",
            "Comfortable mattress with basic bedding",
            "Simple setup for a budget-friendly trip",
            "Perfect for friends and group stays",
          ],
          images: [t1, tent1, tent2, tent3],
          price: 1199,
        },
        {
          title: "Triangle / Pod Stay",
          description:
            "A stylish and cozy option for couples and small groups.",
          features: [
            "Private pod-style stay",
            "Soft pillows and comfortable mattress",
            "Cozy bedding for a relaxed night",
            "Ideal for couples and small groups",
            "Fan and charging point for convenience",
          ],
          images: [ts1, triangle4, triangle1, triangle2],
          price: 1699,
        },
        {
          title: "Cozy Cabin",
          description:
            "A romantic and scenic stay option with a premium camping feel.",
          features: [
            "Private cabin-style comfort",
            "Scenic lake view from the stay",
            "Romantic setting for couples",
            "Cozy ambience with cooler nights",
          ],
          images: [cb1, cb2, cb3],
          price: 2199,
        },
        {
          title: "Farm Style Cottage",
          description:
            "A cozy farmhouse-style stay for families and special weekends.",
          features: [
            "Farm-style comfort and warmth",
            "Enhanced privacy for a relaxed stay",
            "Switchboard and fan for added convenience",
            "Ideal for families and couples",
          ],
          images: [fs2, fs1],
          price: 2199,
        },
        {
          title: "Yellow Glass Room",
          description:
            "Comfort-first stay for guests who want privacy and easy convenience.",
          features: [
            "Private room experience",
            "Stylish yellow glass windows",
            "Perfect for family stays",
            "Fresh, clean, and comfortable ambience",
          ],
          images: [room1, room4, room2, room3],
          price: 1699,
        },
      ],
      imageUrls: [triangle1, triangle2],
      verticalCards: [
        { title: "Card 4", image: cmn1 },
        { title: "Card 10", image: cmn10 },
        { title: "Card 11", image: cmn11 },
        { title: "Card 6", image: cmn6 },
        { title: "Card 12", image: cmn12 },
        { title: "Card 1", image: cmn2 },
        { title: "Card 2", image: cmn3 },
        { title: "Card 3", image: cmn4 },
        { title: "Card 5", image: cmn5 },
        { title: "Card 7", image: cmn7 },
        { title: "Card 8", image: cmn8 },
        { title: "Card 9", image: cmn9 },
        { title: "Card 9", image: cmn13 },
      ],
      faq: [
        {
          question: "How to reach Pawna lake Camping?",
          answer:
            "You can quickly drive to the campsite we provide parking space. Camping is well connected by the national highway a few hours drives from Mumbai, Pune, Lonavala. We’ll provide you with google maps directions after you complete the booking. People using public transport you can get down at Lonavala or Kamshet railway station. From here, jeeps are available on a private rental basis till Pawna Lake Pune. You can also hop on sharing vehicles from Kamshet to Pawna campsite.",
        },
        {
          question: "What is Pawna Camping?",
          answer:
            "Pawna Camping is a popular outdoor adventure experience near Pawna Lake, where guests can enjoy camping, bonfires, BBQ, and various adventure activities like trekking and fishing. The site offers a beautiful view of the lake and surrounding hills.",
        },
        {
          question: "Where is Pawna Camping located?",
          answer:
            "Pawna Camping is located in Lonavala, Maharashtra, India, around 20-25 kilometers from Lonavala city center. The exact location is near Pawna Lake, which is easily accessible by road from Mumbai, Pune, and other nearby areas.",
        },
        {
          question: "What should I bring for camping at Pawna?",
          answer:
            "We provide the necessary camping equipment, such as tents, sleeping bags, and mattresses. However, it is recommended to bring comfortable clothing, a light jacket, personal toiletries, camera, and any medications you may need. Don't forget to bring your adventurous spirit!",
        },
        {
          question: "Is food provided during the camping trip?",
          answer:
            "Yes, food is provided during your stay at Pawna Camping. We serve freshly prepared meals including breakfast, lunch, and dinner. Vegetarian and non-vegetarian options are available. You can also enjoy a BBQ and snacks around the campfire.",
        },
        {
          question: "Are pets allowed at Pawna Camping?",
          answer:
            "Yes, pets are welcome at Pawna Camping! We understand that pets are part of the family, and we encourage you to bring them along. Please ensure they are kept under control and cleaned up after.",
        },
        {
          question: "Can we go boating on Pawna Lake?",
          answer:
            "Yes, boating is available at Pawna Lake. You can enjoy a peaceful boat ride with friends or family, surrounded by the natural beauty of the lake and hills. The boat rides are typically organized by local vendors, and you can inquire about the availability at the campsite.",
        },
        {
          question: "Is Pawna Camping safe for families and children?",
          answer:
            "Yes, Pawna Camping is safe for families and children. The camping site is well-maintained and supervised by experienced staff. The adventure activities are designed to be fun and safe for people of all ages, but it's always a good idea to keep an eye on younger kids.",
        },
        {
          question: "How do I book a spot at Pawna Camping?",
          answer:
            "You can easily book a spot at Pawna Camping through our website or by contacting us via phone or email. We recommend making a reservation in advance, especially on weekends and holidays, as the campsite tends to fill up quickly.",
        },
        {
          question: "What is the best time to visit Pawna Camping?",
          answer:
            "The best time to visit Pawna Camping is between October and March when the weather is cool and pleasant. Monsoon (June to September) offers lush green landscapes, but the region experiences heavy rainfall during this period, which may affect certain activities.",
        },
        {
          question: "Do you provide transportation to the campsite?",
          answer:
            "We do not provide transportation to Pawna Camping, but we can assist you with arranging transport from nearby cities like Mumbai or Pune. Alternatively, you can drive directly to the campsite in your own vehicle.",
        },
        {
          question: "Can I cancel my booking at Pawna Camping?",
          answer:
            "Yes, you can cancel your booking, but please check our cancellation policy on the website. We typically offer a refund (minus a small cancellation fee) if you cancel within a specified period before your check-in date.",
        },

        {
          question: "What are the activities available at Pawna Lake Camping?",
          answer:
            "Below are activities not included in the camping package; these are available near Pawna lake Camping: Paragliding at Pawna, Water sports at Pawna, Lohgad Fort Pune Trek, Visapur Fort Trek, Tung Fort Trek, Tikona Fort Trek, Kamshet Paragliding, Rajmachi fort Trek.",
        },
        {
          question: "Can we charge our phones and gadgets inside the tents?",
          answer:
            "Electricity is available at Pawna Lake Camping, with limited slots. We recommend you carry your power bank. You can spend more time with your friends and family rather than standing next to the charging board.",
        },
      ],
    };

    setData(fetchedData);
  }, []);

  return (
    <div>
      {data ? (
        <PackageInfo data={data} />
      ) : (
        <div className="text-red-600"></div>
      )}
    </div>
  );
};

export default PawanaCamping;
